// Error class thrown by AI wrappers when the quota service denies
// the call. Callers catch this specifically to render an upsell
// toast (with concrete used/limit numbers) instead of a generic
// "something went wrong".
//
//   try {
//     const errors = await checkGrammar(text, locale);
//   } catch (err) {
//     if (err instanceof QuotaExceededError) {
//       showUpsellToast(err.verdict, t);
//     } else {
//       toast.error(t("editor.grammar.failed"));
//     }
//   }
//
// The verdict shape comes from /api/quota/<feature>/consume/:
//
//   { allowed: false, feature, tier, used, limit, remaining, reason }

export class QuotaExceededError extends Error {
  constructor(verdict) {
    super(`quota_exceeded:${verdict?.feature || "unknown"}`);
    this.name = "QuotaExceededError";
    this.verdict = verdict || {};
  }
}

export function isQuotaExceeded(err) {
  return err instanceof QuotaExceededError || err?.name === "QuotaExceededError";
}
